<template>
    <div class="container">
        <div class="handle-box">
          <el-button type="primary" icon="el-icon-plus" @click="handleAdd">添加</el-button>
        </div>
        <el-table
            :data="tableData"
            border
            class="table"
            ref="multipleTable"
            header-cell-class-name="table-header"
        >
          <el-table-column prop="id" label="ID" align="center" width="100" min-width="100"></el-table-column>
          <el-table-column label="类型" align="center" text-align="left" width="200">
            <template #default="scope">
                {{ scope.row.type == 1 ? "常见问题" : "使用说明" }}
            </template>
          </el-table-column>
          <el-table-column prop="question" :label="query.type==1?'标题/问题':'标题/说明'" show-overflow-tooltip header-align="center"></el-table-column>
          <el-table-column label="操作" width="180" align="center">
            <template #default="scope">
              <el-button
                  type="text"
                  icon="el-icon-edit"
                  @click="handleEdit(scope.$index, scope.row)"
              >编辑
              </el-button>
              <el-button
                  type="text"
                  icon="el-icon-delete"
                  class="red"
                  @click="handleDelete(scope.row.id)"
              >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
              background
              layout="total, prev, pager, next"
              :current-page="query.page"
              :page-size="query.page_size"
              :total="pageTotal"
              @current-change="handlePageChange"
          ></el-pagination>
        </div>
  
      <!-- 编辑弹出框 -->
      <el-dialog title="编辑" v-model="editVisible" width="80%">
        <el-form ref="form" :model="form" class="el-dialog__body" label-width="80px">
          <el-form-item label="问题" required>
            <el-input v-model="form.question"></el-input>
          </el-form-item>
          <el-form-item v-show="form.type == 1 ? false : true" label="内容" required>
            <tinymce-text id="tinymce" @input="tinymcechange" @release="release"
                          v-model:value="form.answer"></tinymce-text>
          </el-form-item>
          <el-form-item v-show="form.type == 2 ? false : true" label="回答">
            <tinymce-text id="tinymce" @input="tinymcechange" @release="release"
                          v-model:value="form.answer"></tinymce-text>
          </el-form-item>
        </el-form>
        <template #footer>
                  <span class="dialog-footer">
                      <el-button @click="editVisible = false">取 消</el-button>
                      <el-button type="primary" @click="saveEdit">确 定</el-button>
                  </span>
        </template>
      </el-dialog>
    </div>
  </template>
  
  <script>
  import moment from "moment";
  import TinymceText from '../components/TinymceText'
  import {getArticleList, saveArticle, deleteArticle} from "@/api/article";
  import { ref } from 'vue'
  
  export default {
    name: "ArticleTable",
    components: {TinymceText},
    data() {
      return {
        action: 'https://wx.yixiankeji.com/admin/upload',
        query: {
          type: 2,
          page: 1,
          page_size: 10
        },
        tableData: [],
        editVisible: false,
        pageTotal: 0,
        form: {},
        idx: -1,
        id: -1,
        type:2
      };
    },
    created() {
      this.getData();
    },
    computed: {
  
    },
    methods: {
      handleClose(tag) {
        this.form.weekdays.splice(this.form.weekdays.indexOf(tag), 1)
      },
      // eslint-disable-next-line no-unused-vars
      release(content) {
      },
      tinymcechange(content) {
        this.form.content = content
        // this.$emit("tinymcechange", e);
      },
      dateFormat: function (row, column) {
        const date = row[column.property];
        if (date === undefined) {
          return "";
        }
        return moment(parseInt(date + "000")).format("YYYY-MM-DD")
      },
  
      getData() {
        this.query.type = this.type
        getArticleList(this.query).then(res => {
          this.tableData = res.data
          if (this.query.page === 1) {
            this.pageTotal = res.count
          }
        })
      },
      // 触发搜索按钮
      handleSearch() {
        this.query.page = 1
        this.getData()
      },
      // 删除操作
      handleDelete(id) {
        // 二次确认删除
        this.$confirm("确定要删除吗？", "提示", {
          type: "warning"
        }).then(() => {
          deleteArticle(id).then(res => {
            if (res === true) {
              this.$message.success("删除成功")
            }
            this.getData()
          })
        }).catch(() => {
        });
      },
      // 添加操作
      handleAdd() {
        this.form = {}
        this.form.id = 0
        this.form.type = this.type
        this.editVisible = true
      },
      // 编辑操作
      handleEdit(index, row) {
        this.idx = index;
        this.form.id = row.id
        this.form.type = this.type
        this.form.question = ref(row.question)
        this.form.answer = ref(row.answer)
        this.editVisible = true
      },
  
      // 保存编辑
      saveEdit() {
        let param = {
          "type" : parseInt(this.form.type),
          "question" : this.form.question,
          "answer" : this.form.content,
        }
        saveArticle(this.form.id, param).then(res => {
          if (res === true) {
            this.$message.success("保存成功")
            this.editVisible = false
            this.getData()
          }
        })
      },
  
      // 分页导航
      handlePageChange(val) {
        this.query.page = val
        getArticleList(this.query).then(res => {
          this.tableData = res.data
        })
      },
  
    }
  };
  </script>
  
  <style scoped>
  .handle-box {
    margin-bottom: 10px;
  }
  
  .handle-select {
    width: 120px;
  }
  
  .handle-input {
    width: 200px;
    display: inline-block;
  }
  
  .table {
    width: 100%;
    font-size: 14px;
  }
  
  .red {
    color: #ff0000;
  }
  
  .mr10 {
    margin-right: 10px;
  }
  
  .table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
  }
  
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  
  .el-dialog__body {
    height: 50vh;
    overflow: auto;
  }
  </style>
  